import { useAppDispatch } from '@/store/hooks';
import { usePaymentsConfig } from '@/services/paymentsConfig/usePaymentsConfig';

import { setProvider, ProviderName } from './paymentSelectSlice';
import CardPaymentButton from './CardPaymentButton';

// Just the single option for now, but this gives us ability to easily expand the
// number of monthly providers, and also makes this exportable in other context:
export const monthlyProviderConfigs = [
  {
    name: 'GOCARDLESS',
    Component: CardPaymentButton,
    label: 'Pay by Direct Debit',
    testId: 'paymentSelectDirectDebit'
  }
];

function ProviderSelectMonthly() {
  const dispatch = useAppDispatch();

  const { isProviderAvailable } = usePaymentsConfig();

  const providerGroup = 'monthly';

  const handleProviderSelect = (provider: ProviderName) => {
    dispatch(setProvider(provider));
  };

  return (
    isProviderAvailable(providerGroup, 'GOCARDLESS') ? (
      <div>
        {monthlyProviderConfigs.map(({
          name, Component, label, testId
        }) => isProviderAvailable(providerGroup, name) && (
          <Component
            key={name}
            onClick={() => handleProviderSelect(name as ProviderName)}
            testId={testId}
          >
            {label}
          </Component>
        ))}
      </div>
    ) : (
      null
    )
  );
}

export default ProviderSelectMonthly;
